import React, { useRef, useEffect, useCallback, useMemo } from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { incrementSelectedPinZIndex } from "utilities/appStatics";
import { selectExploreMapPin, handleExploreViewObjectVisibilityChange, appNotify } from "store/actions";
import { addCommaSeparatorToNumber } from "utilities/format";
import PropertyDataPins from 'components/explore/gmap/PropertyDataPins';

function PinManager({ selectExploreMapPin, selectedPinIds = null,
  propertyDataObjects, autoBreakoutThreshold, handleExploreViewObjectVisibilityChange, visiblePinCount, appNotify }) {
  const ctrlKeyDown = useRef(false);   
  useEffect(() => {
    window.addEventListener("keydown", onCtrlDown);
    window.addEventListener("keyup", onCtrlUp);
    return () => {
      window.removeEventListener("keydown", onCtrlDown);
      window.removeEventListener("keyup", onCtrlUp);
    }
  }, []);

  const visiblePdoIds = useMemo(() => {
    const ids = [];
    Object.keys(propertyDataObjects).forEach(id => {
      if (!propertyDataObjects[id].pinsAreVisible) return;
      const parsedId = isNaN(parseInt(id)) ? id : parseInt(id);
      ids.push(parsedId);
    });
    return ids;
  }, [propertyDataObjects]);

  useEffect(() => {
    if (visiblePinCount > autoBreakoutThreshold) {
      appNotify(`Exceeded limit of ${autoBreakoutThreshold} property pins. ${addCommaSeparatorToNumber(visiblePdoIds.length)} Property Data objects have been automatically hidden.`, 'warning', { autoHideDuration: 10000 });
      handleExploreViewObjectVisibilityChange(visiblePdoIds, false);
    }
  }, [visiblePinCount]);

  useEffect(() => {
    incrementSelectedPinZIndex();
  }, [selectedPinIds]);

  const onCtrlDown = event => {
    if (!ctrlKeyDown.current && event.keyCode === 17) {
      ctrlKeyDown.current = true;
    }
  }

  const onCtrlUp = event => {
    if (ctrlKeyDown.current && event.keyCode === 17) {
      ctrlKeyDown.current = false;
    }
  }

  const onPinClick = useCallback((event, clusterID, objectId) => {
    let mouseEvent = Object.values(event).find(p => p instanceof MouseEvent);//google didn't provide api to access dom click event
    const ctrlKey = mouseEvent ? mouseEvent.ctrlKey : ctrlKeyDown.current;
    selectExploreMapPin({
      ctrlKey,
      objectId,
      clusterID,
      shouldSelectShape: true // Pass true to auto-select a corresponding shape if it exists
    })
  }, [selectExploreMapPin]);

  if (visiblePinCount > autoBreakoutThreshold) {
    return [];
  } else {
    return visiblePdoIds.map(objectId => {
      return <PropertyDataPins objectId={objectId} onPinClick={onPinClick}/>
    });
  }
}

function mapState({ exploreMap, exploreData }) {
  const { markerOptions } = exploreMap;
  const { propertyDataObjects } = exploreData;
  const visiblePinCount = Object.keys(propertyDataObjects).reduce((sum, key) => {
    const { propertyData, pinsAreVisible } = propertyDataObjects[key];
    if (pinsAreVisible) {
      sum += propertyData.length;
    }
    return sum;
  }, 0);

  return {
    autoBreakoutThreshold: markerOptions.autoBreakoutThreshold,
    selectedPinIds: exploreData.selectedIdsContext ? exploreData.selectedIdsContext.ids : null,
    propertyDataObjects,
    visiblePinCount
  };
}
const mapDispatch = {
  selectExploreMapPin,
  handleExploreViewObjectVisibilityChange,
  appNotify
};

export default compose(
  connect(mapState, mapDispatch)
)(PinManager);
